<template>
  <div class="rescue global-rescue">
    <BackTop></BackTop>
    <div class="main">
      <Breadcrumb class="bread rescueBread"
                  separator=">">
        <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem>
        <BreadcrumbItem to="/rescue">全球救援</BreadcrumbItem>
        <BreadcrumbItem class="bread-last">其他旅行援助</BreadcrumbItem>
      </Breadcrumb>
      <h3 class="rescue-bigtitle">其他旅行援助</h3>
      <p class="experience-para">北京威马捷承接保险公司委托的非医疗旅行救援服务，在熟知保险理赔条款的基础上，提供初期报案受理，理赔方法说明及事故报告 等服务。协助客户就飞机延误，行李延误，行李破损，损害赔偿等事故进行理赔。
      </p>
      <h4 class="rescue-title">服务内容介绍</h4>
      <div class="experience-part">
        <table class="other-service">
          <thead>
            <tr>
              <th>服务项目</th>
              <th>服务内容</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>基本对应</td>
              <td>24小时救援客服中心应答被保险者来电。确认必要信息后就被保险者的诉求说明保险条款及理赔手续，并告知理赔所需材料。对应完毕后根据案件记录作成报告书发送给保险公司。 </td>
            </tr>
            <tr>
              <td>行李损失</td>
              <td>被保险者在海外旅行期间的行李物品如发生偷盗、破损等情况时，威马捷会指导被保险者取得当地警察局的证明照片，或留存证明照片。并且详细说明保险理赔条款及限额。</td>
            </tr>
            <tr>
              <td>航班延误 </td>
              <td>被保险者在旅行过程中发生航班延误情况，威马捷在确认原航班信息及延误事实后，指导被保险者取得延误证明并留存登机牌等理赔必要材料。并根据被保险者在延误机场实际发生的食宿费及原本因预定行程取消而额外支出的赔偿金情况说明理赔范围及申请方法。</td>
            </tr>
            <tr>
              <td>行李延误</td>
              <td>如在旅行过程中发生托运行李延误或未到达旅行目的地等情况，威马捷会确认被保险人的旅行行程、航班信息及托运行李延误情况，并说明理赔范围及申请方法。</td>
            </tr>
            <tr>
              <td>赔偿责任 </td>
              <td>如发生在旅行目的地或酒店等公共场所损坏了公共/他人财物或致使他人受伤等情况，确认具体情况后为被保险者说明理赔所需材料及申请方法。如保险公司有特殊委托，可以为被保险者垫付理赔金。</td>
            </tr>
          </tbody>
        </table>
        <img class="service-img"
             :src="service"
             alt="">
      </div>

    </div>
  </div>
</template>
<script>
import service from '@/assets/images/rescue/service1.png'
export default {
  data () {
    return {
      service
    }
  },
  mounted () {

  }
}
</script>
<style lang="less" scoped>
.rescue-bigtitle {
  margin-bottom: 39px;
}
.experience-para {
  font-size: 16px;
  line-height: 32px;
  width: 100%;
  margin-bottom: 88px;
}
.experience-part {
  border: none;
  padding-top: 0;
  padding-bottom: 0;
  padding-bottom: 0;
}
.other-service {
  width: 894px;
  margin: 0 auto;
  tr {
    th {
      background: #bbd2ed;
      color: #1d1812;
      font-size: 24px;
      line-height: 60px;
      border: 2px solid #fff;
    }
    td {
      &:first-child {
        width: 268px;
        font-size: 24px;
        color: #242424;
        text-align: center;
      }
      &:last-child {
        font-size: 20px;
        color: #242424;
        line-height: 36px;
        padding: 16px;
      }
    }
  }
  tbody {
    tr {
      &:nth-child(odd) {
        background: #ebf3fe;
      }
      &:nth-child(even) {
        background: #dce6f2;
      }
      td {
        border: 2px solid #fff;
      }
    }
  }
}
.service-img {
  display: block;
  width: 883px;
  margin: 40px auto 100px auto;
}
</style>